import { getFileType } from '@/utils/tools'
const mixin = {
  methods: {
    isImageList (fileDetail) {
      let suffixType = fileDetail.suffixType ? fileDetail.suffixType : ''
      let lowerType = suffixType.toLowerCase()
      let officeExt = ['doc', 'docx', 'pdf', 'ppt', 'pptx']
      if ($.inArray(lowerType, officeExt) !== -1 && fileDetail.pics && fileDetail.pics.length) {
        return true
      } else {
        return false
      }
    },
    isOffice (suffixType = '') {
      let lowerType = suffixType.toLowerCase()
      let officeExt = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      if ($.inArray(lowerType, officeExt) !== -1) {
        return true
      }
    },
    isZip(suffixType = '') {
      let lowerType = suffixType.toLowerCase()
      let officeExt = ['zip', 'rar']
      if ($.inArray(lowerType, officeExt) !== -1) {
        return true
      }
    },
    getFileType (filesuffix) {
      return getFileType(filesuffix)
    },
  }
}

export default mixin



// WEBPACK FOOTER //
// ./src/pages/preview/mixins/resourceProduction.js